// src/features/dashboard/components/QuickActions.tsx

import React from 'react';
import { motion } from 'framer-motion';
import { Plus } from 'lucide-react';
import { QuickActionConfig } from '../types';
import Skeleton from '../../../components/Skeleton';

interface QuickActionsProps {
  actions: QuickActionConfig[];
  loading?: boolean;
}

// Quick action buttons grid
export const QuickActions = React.memo<QuickActionsProps>(({ actions, loading = false }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 0.3 }}
      className="theme-card rounded-lg border theme-border"
    >
      <div className="px-4 py-3 border-b theme-border">
        <h2 className="text-base font-semibold theme-card-title flex items-center gap-2">
          <Plus className="w-4 h-4 theme-card-subtitle" />
          Quick Actions
        </h2>
      </div>
      <div className="p-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {loading ? (
            Array.from({ length: 4 }).map((_, index) => (
              <Skeleton key={index} variant="rounded" height={44} className="w-full" />
            ))
          ) : (
            actions.map((action) => (
              <button
                key={action.label}
                onClick={action.onClick}
                className={`px-4 py-3 rounded-lg bg-gradient-to-r ${action.gradient} text-white hover:opacity-90 transition-all duration-200 text-sm font-medium flex items-center justify-center gap-2 shadow-sm`}
              >
                <action.icon className="w-4 h-4" />
                {action.label}
              </button>
            ))
          )}
        </div>
      </div>
    </motion.div>
  );
});

QuickActions.displayName = 'QuickActions';
